export default __webpack_public_path__ + "static/media/header_pantalla_generica_movil_kmi_sep20.66b82926.png";